import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '../api/api';
import { FaGraduationCap, FaBook, FaImage, FaVideo, FaChalkboardTeacher, FaLock, FaShieldAlt } from 'react-icons/fa';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { data } = await login(form);
      localStorage.setItem('sbs_token', data.token);
      navigate('/open');
    } catch {
      setError('Invalid username or password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      background: 'linear-gradient(135deg, var(--blue) 0%, #1d4ed8 100%)',
    }}>
      {/* Left panel */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '3rem',
        color: 'var(--white)',
      }}>
        <div style={{ maxWidth: 400, textAlign: 'center' }}>
          <div style={{ fontSize: '4rem', marginBottom: '1rem', display: 'flex', justifyContent: 'center', color: '#fff' }}><FaGraduationCap size={64} /></div>
          <h1 style={{ fontSize: '2rem', fontWeight: 800, marginBottom: '0.8rem' }}>
            SBS Institute<br />of Coaching
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.75)', lineHeight: 1.7 }}>
            Admin portal for managing courses, notes, gallery, and videos.
          </p>
          <div style={{ marginTop: '2rem', display: 'flex', flexDirection: 'column', gap: '0.7rem' }}>
            {[
              { icon: <FaBook size={16} />, text: 'Upload Study Notes', color: '#3B82F6' },
              { icon: <FaImage size={16} />, text: 'Manage Gallery', color: '#10B981' },
              { icon: <FaVideo size={16} />, text: 'Add Video Lectures', color: '#F59E0B' },
              { icon: <FaChalkboardTeacher size={16} />, text: 'Create Courses', color: '#EF4444' },
            ].map(({ icon, text, color }) => (
              <div key={text} style={{
                background: 'rgba(255,255,255,0.1)',
                border: '1px solid rgba(255,255,255,0.15)',
                borderRadius: 8, padding: '0.6rem 1rem',
                fontSize: '0.9rem', textAlign: 'left',
                display: 'flex', alignItems: 'center', gap: '0.6rem',
                transition: 'all 0.3s ease',
              }}
                onMouseEnter={e => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
                  e.currentTarget.style.borderColor = color;
                  e.currentTarget.style.transform = 'translateX(5px)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                  e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)';
                  e.currentTarget.style.transform = 'translateX(0)';
                }}
              >
                <span style={{ color }}>{icon}</span> {text}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right panel — form */}
      <div style={{
        width: '100%',
        maxWidth: 460,
        background: 'var(--white)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '3rem 2.5rem',
      }}>
        <div style={{ width: '100%' }}>
          <div style={{ marginBottom: '2rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.8rem' }}>
              <FaShieldAlt size={24} color="var(--blue)" />
              <h2 style={{ fontSize: '1.7rem', fontWeight: 800, color: 'var(--dark)' }}>
                Secure Access
              </h2>
            </div>
            <p style={{ color: 'var(--gray)', marginTop: '0.4rem', fontSize: '0.9rem' }}>
               Sign in to your account
            </p>
          </div>

          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label>Username</label>
              <input
                value={form.username}
                onChange={e => setForm({ ...form, username: e.target.value })}
                placeholder="Enter your username"
                autoComplete="username"
                required
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
                placeholder="Enter your password"
                autoComplete="current-password"
                required
              />
            </div>

            {error && <div className="alert alert-error" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}><FaLock size={14} /> {error}</div>}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                background: loading ? 'var(--gray)' : 'var(--blue)',
                color: 'var(--white)',
                padding: '0.9rem',
                borderRadius: 8,
                border: 'none',
                fontWeight: 700,
                fontSize: '1rem',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'background 0.2s',
                marginTop: '0.5rem',
              }}
            >
              {loading ? 'Signing in...' : 'Sign In →'}
            </button>
          </form>



          <p style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.85rem', color: 'var(--gray)' }}>
            <Link to="/" style={{ color: 'var(--blue-mid)', fontWeight: 600 }}>← Back to Website</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
